import { useEffect, useRef, useState } from "react";
import useMedia from "use-media";
import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css";
import "../../../../src/index.css";
import "../../../resources/css/common/calendar.css";
import "../../../resources/css/search/search.css";
import { GetPublicHoliday } from "../../../../src/hooks/getPublicHoliday";
import { connect, useStore } from "react-redux";
import { ModalClose } from "../../atoms/modalClose";
import { Button } from "../../atoms/button";
import commonUtil from "../../../common/commonUtil";
import { Label } from "../../atoms/label";
import { Image } from "../../atoms/image";
import cross from '../../../resources/icons/ico_X.svg';
import circle from '../../../resources_membership_hotel/icons/ico_circle.svg';
import minus from '../../../resources_membership_hotel/icons/ico_minus.svg';
import slash from '../../../resources_membership_hotel/icons/ico_slash.svg';
import square from '../../../resources_membership_hotel/icons/ico_square.svg';
import triangle from '../../../resources_membership_hotel/icons/ico_triangle.svg';
import { getCourseInfo } from "../../../const";
import common from "../../../resources_catalog/js/common/common";

export const EstheticAndRestaurantCalendarContainer = (props) => {
    const {
        state,
        estheRsvInfo,
        setEstheRsvInfo,
        restaurantReserveInfo,
        setRestaurantReserveInfo,
        estheticInfo,
        onClickOpenCalendarWindow,
        onClickOpenPopupWindow,
        setCalendarFlg,
        setPopupData,
        cornerBunKbn
        } = props;

    // 祝日取得用カスタムフック
    const { getHoliday } = GetPublicHoliday();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [selectDate1, setSelectDate1] = useState("");
    const [activeStartDate, setActiveStartDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const vacancyItems = state.vacancyItems ? state.vacancyItems : [];
    const firstDate = useRef(null);
    const count = useRef(0);

    const store = useStore();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    // プレー日欄に表示する日付取得(初回レンダリング時)
    useEffect(() => { 
        let selectDate = new Date();
        let riyoDate = "";
        
        // カレンダー最大選択範囲
        let maxDate = new Date();
        if (cornerBunKbn == "1") {
            maxDate.setFullYear(maxDate.getFullYear() + 1);
        } else if (cornerBunKbn == "2") {
            maxDate.setDate(maxDate.getDate() + 2);
        }
        setMaxDate(maxDate);
        
        // カレンダー最小選択範囲
        let minDate = new Date();
        if (cornerBunKbn == "1") {
            minDate.setDate(minDate.getDate() + 3);
        }
        setMinDate(minDate);

        // カレンダー表示起点日
        //storeにdateが入っていればそちらを使う
        if (cornerBunKbn == "1") {
            riyoDate = store.getState().restaurantReserveInfo?.riyoDate;
        } else if (cornerBunKbn == "2") {
            riyoDate = store.getState().estheRsvInfo?.riyoDate;
        }
        let playDate1 = riyoDate ? new Date(riyoDate) : minDate;
        let monthCnt = diffMonth(selectDate,playDate1);
        count.current = monthCnt;
        setSelectDate1(playDate1);
        setActiveStartDate(playDate1);
        
        let now = new Date();
        if (cornerBunKbn == "1") {
            now.setDate(now.getDate() + 3);
        }
        let first = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        firstDate.current = first;

    }, [state.calendarFlg]);

    useEffect(() => {
        // 次へ表示ボタンに関数登録
        const nextElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__next-button");
        nextElm[0].addEventListener("click", nextDate);

        // 戻る表示ボタンに関数登録
        const prevElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__prev-button");
        prevElm[0].addEventListener("click", prevDate);
    },[]);

    // 次へ表示制御
    const nextDate = () => {
        let activeDate = new Date();
        activeDate.setDate(1);
        count.current += 1;
        activeDate.setMonth(activeDate.getMonth() + count.current);

        let date = new Date();
        date.setDate(25);
        date.setMonth(date.getMonth() + count.current - 1);

        // 利用日付
        let startDate;
        const current =  firstDate.current
        if(current >= date){
            startDate = commonUtil.getStringFromDate(new Date(current), "yyyy-MM-dd");
        } else {
            startDate = commonUtil.getStringFromDate(new Date(date), "yyyy-MM-dd");
        }

        if (cornerBunKbn == "1") {
            let reqRestaurantInfo = {...store.getState().restaurantInfo};
            let reqReserveInfo = {...store.getState().restaurantReserveInfo};
            reqReserveInfo.riyoDate = startDate;
            onClickOpenCalendarWindow(reqRestaurantInfo, reqReserveInfo)
        } else if (cornerBunKbn == "2") {
            let reqEstheticInfo = {...store.getState().estheticInfo};
            let reqReserveInfo = {...store.getState().estheRsvInfo};
            reqReserveInfo.riyoDate = startDate;
            onClickOpenCalendarWindow(reqEstheticInfo, reqReserveInfo);
        }
        setActiveStartDate(activeDate);
    }

    // 戻る表示制御
    const prevDate = () => {
        let activeDate = new Date();
        activeDate.setDate(1);
        count.current -= 1;
        if (count.current < 0) {
            count.current = 0;
            return;
        }
        activeDate.setMonth(activeDate.getMonth() + count.current);

        let date = new Date();
        date.setDate(25);
        date.setMonth(date.getMonth() + count.current - 1);

        // 利用日付
        let startDate;
        const current =  firstDate.current
        if(current >= date){
            startDate = commonUtil.getStringFromDate(new Date(current), "yyyy-MM-dd");
        } else {
            startDate = commonUtil.getStringFromDate(new Date(date), "yyyy-MM-dd");
        }

        if (cornerBunKbn == "1") {
            let reqRestaurantInfo = {...store.getState().restaurantInfo};
            let reqReserveInfo = {...store.getState().restaurantReserveInfo};
            reqReserveInfo.riyoDate = startDate;
            onClickOpenCalendarWindow(reqRestaurantInfo, reqReserveInfo)
        } else if (cornerBunKbn == "2") {
            let reqEstheticInfo = {...store.getState().estheticInfo};
            let reqReserveInfo = {...store.getState().estheRsvInfo};
            reqReserveInfo.riyoDate = startDate;
            onClickOpenCalendarWindow(reqEstheticInfo, reqReserveInfo);
        }
        setActiveStartDate(activeDate);
    }

    const diffMonth = (d1, d2) => {
        let d1Month, d2Month;
       
        d1Month = d1.getFullYear() * 12 + d1.getMonth();
        d2Month = d2.getFullYear() * 12 + d2.getMonth();
       
        return d2Month - d1Month;
      }

    // コース一覧取得後処理
    const afterGetCourseInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let courseList = [];
            courseList = data.courseList.filter(value => value.optionKbn == "1")
            setPopupData({
                courseList: courseList,
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                rstEstheCd: estheticInfo.estheticCd,
            });
            onClickOpenPopupWindow("mainCourse");
        }
    }

    // コースポップアップ表示
    const onClickCourse = (date) => {
        // コース情報取得
        let req = {
            honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
            shisetsuCd: estheticInfo.shisetsuCd,
            cornerBunKbn: "2", /* 固定値 */
            rstEstheCd: estheticInfo.estheticCd,
            jikantai: "1",
            //riyoDate: estheRsvInfo.riyoDate,
            riyoDate: date,
        }
        common.doPost(getCourseInfo, req, afterGetCourseInfo);
        setPopupData({
            courseList: []
        });
    }

    // プレー日欄に表示する日付取得
    const getDateToString = (val, event) => {
        // 「満室」「クローズ」「予約受付対象外」は遷移させない
        if (!vacancyItems) return
        const targetDate = commonUtil.getStringFromDate(new Date(val), "yyyy-MM-dd");
        const vacancyMark = vacancyItems.find(value => {
            return commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") === targetDate
        }).mark
        if (vacancyMark === "×" || vacancyMark === "－" || vacancyMark === "／") {
          return
        }
        let playDate1 = new Date(val);
        let y = playDate1.getFullYear();
        let m = playDate1.getMonth() + 1;
        let d = playDate1.getDate();
        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`
        const riyoDate = y + "-" + m + "-" + d
        // 選択項目の移動
        setSelectDate1(val);
        if (cornerBunKbn == "1") {
            if (riyoDate !== restaurantReserveInfo.riyoDate) {
                setRestaurantReserveInfo({ ...restaurantReserveInfo, riyoDate: riyoDate });
            }
            onClickOpenPopupWindow("people");
        } else if (cornerBunKbn == "2") {
            if (riyoDate !== estheRsvInfo.riyoDate) {
                setEstheRsvInfo({ ...estheRsvInfo, riyoDate: riyoDate });
            }
            onClickCourse(riyoDate);
        }
        setCalendarFlg(false);
    };

    // カレンダーの月表示を大きくするための関数
    const layoutChangeOfMonth = (date) => {

        const label = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[0];
        const y = date.getFullYear();
        const m = date.getMonth() + 1;

        if (label) {
            label.style.width = "100%";
            label.style.padding = "0";
            label.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
        }
    };

    //日付の内容を出力
    const getTileContent = (calendar) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(calendar.date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        if (vacancyItems) {
            vacancyItems.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.mark;
                }
            })
        }

        // タイルに表示する内容を返却
        return (
            <div style={{ height: "30%" }}>
                <Label
                    style={maxDate > calendar.date ?
                        vacancy === "○" ? (
                            style.circle
                        ) : (vacancy === "×" ? (
                            style.cross
                        ) : (vacancy === "－" ? (
                            style.minus
                        ) : (
                            style.occupy
                        )))
                        :null
                    }
                />
            </div>
        );
    }

    const onClickClose = () => {
        // ポップアップの表示・非表示用更新関数
        setCalendarFlg(false);
    }

    return (
        <div style={state.calendarFlg ? style.popupIsShow : style.popup} id="js-popup">
            <div className="popupInner_Calendar estheticAndRestaurantCalendar">
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClose} />
                <h4 style={isMobilePhone ? style.popupInnerTextSp : style.popupInnerText}>利用日</h4>
                {isMobilePhone ?
                    (<Calendar
                        activeStartDate={activeStartDate}
                        locale={"ja-JP"}
                        calendarType={"US"}
                        maxDate={maxDate}
                        minDate={minDate}
                        value={null}
                        showDoubleView={false}
                        onClickDay={(val, event) => getDateToString(val, event)}
                        formatDay={(locale, date) => date.getDate()}
                        tileClassName={({ activeStartDate, date, view }) => getHoliday(activeStartDate, date, view) + " right_none"}
                        formatMonthYear={(locale, date) => layoutChangeOfMonth(date)}
                        nextLabel={""}
                        prevLabel={""}
                        next2Label={null}
                        prev2Label={null}
                        tileContent={getTileContent}
                    />
                    ) :
                    (<Calendar
                        activeStartDate={activeStartDate}
                        locale={"ja-JP"}
                        calendarType={"US"}
                        maxDate={maxDate}
                        minDate={minDate}
                        value={null}
                        showDoubleView={false}
                        onClickDay={(val, event) => getDateToString(val, event)}
                        formatDay={(locale, date) => date.getDate()}
                        tileClassName={({ activeStartDate, date, view }) => getHoliday(activeStartDate, date, view) + " right_none"}
                        formatMonthYear={(locale, date) => layoutChangeOfMonth(date)}
                        nextLabel={""}
                        prevLabel={""}
                        next2Label={null}
                        prev2Label={null}
                        tileContent={getTileContent}
                    />
                    )}
                {/* <div style={isMobilePhone ? style.buttonAreaMobile : style.buttonArea}>
                    <Button buttonText="決定" className={"selectBtn"} onClick={decision} />
                </div> */}
                <div style={isMobilePhone ? style.descriptionAreaMobile : style.descriptionArea}>
                        <div style={isMobilePhone ? { textAlign: "left", display: "flex", marginTop: "6rem", marginLeft: "10px", flexWrap: "wrap", whiteSpace: "nowrap" }
                            : { textAlign: "left", display: "flex", marginTop: "1rem", marginLeft: "10px", whiteSpace: "nowrap" }}>
                            <div style={style.tableImageStyle}>
                                <Image image={circle} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":空きあり"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={cross} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":空きなし"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={minus} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":クローズ"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                        </div>
                    <div style={cornerBunKbn == "1" ? { textAlign: "left", marginLeft: "10px", color: "rgb(173, 173, 173)" } : { display: "none" }}>
                        <Label label="※本日・明日・明後日のご予約はお電話にてご連絡ください" style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                    </div>
                    </div>
            </div>
            <div style={style.blackBackground} id="js-black-bg"></div>
        </div>
    );
};
const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        // transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        // transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "65%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
        height: "80vh",
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom:"1px solid #eee",
        margin:0,
        padding:"20px 0px 20px 0px"
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0 40px 0",
    },
    buttonAreaMobile: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0 15px 0",
    },
    descriptionArea: {
        width: "90%",
        textAlign: "center",
        padding: "10px 5% 10px 5%",
    },
    descriptionAreaMobile: {
        width: "100%",
        textAlign: "center",
        padding: "0 0 0 0",
    },
    circle: {
        backgroundImage: `url(${circle})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
        padding: "10px 0px 0px 0px",
    },
    triangle: {
        backgroundImage: `url(${triangle})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    square: {
        backgroundImage: `url(${square})`,
        height: 10,
        width: 13,
        margin: "0 auto",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    cross: {
        backgroundImage: `url(${cross})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    minus: {
        backgroundImage: `url(${minus})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    slash: {
        backgroundImage: `url(${slash})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    occupy: {
        height: "auto",
        border: "0px",
        display: "block",
        opacity: "0.5",
        color: "black",
        fontSize: "1px",
    },
    tableImageStyle: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
    },
    imageStyle: {
        width: "11px",
        margin: "auto",
    },
    imageStyleMobile: {
        width: "11px",
        margin: "auto",
    },
    usageGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
    },
    usageGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0.2rem",
    },
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        estheRsvInfo: state.estheRsvInfo,
        estheticInfo: state.estheticInfo,
        restaurantInfo: state.restaurantInfo,
        restaurantReserveInfo: state.restaurantReserveInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setEstheRsvInfo: (item) => {
            dispatch({ type: "ESTHE_RSV_INFO", payload: { estheRsvInfo: item } })
        },
        setRestaurantReserveInfo: (item) => {
            dispatch({ type: "RESTAURANT_RESERVE_INFO", payload: { restaurantReserveInfo: item } })
        },
    };
}
export default connect(mapStateToProps, mapToDispatchToProps)(EstheticAndRestaurantCalendarContainer);